/* eslint-disable */
import PropTypes from 'prop-types';
import FormikSelectField from './FormikSelectField';

const FormikSelectFieldWithClearError = ({ clearBackendError, name, onChange, ...props }) => {
  const handleChange = (e) => {
    // Clear backend error when user changes selection
    if (clearBackendError && name) {
      clearBackendError(name);
    }
    // Call original onChange if provided
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <FormikSelectField
      name={name}
      {...props}
      onChange={handleChange}
    />
  );
};

FormikSelectFieldWithClearError.propTypes = {
  clearBackendError: PropTypes.func,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export default FormikSelectFieldWithClearError;
